export default __webpack_public_path__ + "static/media/grifinoria.2959b2bc.png";